import { RequestQueryParamsModel } from "../interface/http.interface";

export class MasterTypeQueryParams implements RequestQueryParamsModel {
  name = "";

  constructor(name: string) {
    this.name = name;
  }
}
